import { AuthError as MsalAuthError } from "@azure/msal-browser";
import { AlertIcon, GiftIcon } from "../ui/Icons";

interface IAuthErrorProps {
  error: MsalAuthError | null;
}

/** Pantalla de error cuando MSAL no puede completar la autenticacion */
export default function AuthError({ error }: IAuthErrorProps) {
  return (
    <div className="login">
      <div className="login__card">
        <div className="login__mark">
          <GiftIcon size={25} />
        </div>

        <h1 className="login__title">No pudimos iniciar sesión</h1>

        <div
          className="banner banner--err"
          style={{ marginTop: 16, textAlign: "left" }}
        >
          <span className="banner__icon">
            <AlertIcon size={15} />
          </span>
          <span>
            {error?.errorMessage || error?.errorCode || "Error desconocido"}
          </span>
        </div>

        <button
          type="button"
          className="btn btn--primary btn--block"
          onClick={() => window.location.reload()}
        >
          Reintentar
        </button>
      </div>
    </div>
  );
}
